module.exports = __webpack_public_path__ + "227afd561b09067e2bad4f08380ac08e.png";